/* Product recommendations (§11.1). Loads when near the viewport: tries each intent in order
   (complementary → related) and hides the section if none returns products. */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        this.observer.disconnect();
        this.load();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  async load() {
    for (const intent of (this.dataset.intents || 'related').split(',')) {
      try {
        const response = await fetch(`${this.dataset.url}&intent=${intent}`);
        if (!response.ok) continue;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('product-recommendations');
        if (fresh && fresh.querySelector('[data-rec-item]')) {
          this.innerHTML = fresh.innerHTML;
          return;
        }
      } catch (error) {
        /* try the next intent */
      }
    }
    const section = this.closest('.shopify-section');
    if (section) section.hidden = true;
  }
}

if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
